import React, {useEffect, useState} from 'react';
import {Image, Text, View} from 'react-native';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import {Colors} from '../../../../constants/Colors';
import {styles} from './styles';

interface IProductsModalList {
  item: IItem;
}

const ProductModalList = ({item}: IProductsModalList) => {
  const [showTrash, setShowTrash] = useState<boolean>(false);

  useEffect(() => {
    if (!item) {
      setShowTrash(true)
    }
  }, [])

  const status = item?.BEZEI && !Array.isArray(item.BEZEI) && (item.BEZEI as string).trim() !== '' ? (item.BEZEI as string).trim().endsWith('por') ? (item.BEZEI as string).trim().slice(0, -3) : item.BEZEI : 'Confirmado';
  const statusColor = status === 'Confirmado' ? Colors.GreenPallete.greenOne : Colors.RedPallete.red;

  return (
    <View style={{flexDirection: 'row', alignItems: 'center'}}>
      {!showTrash && (<View style={styles.card}>
        {/* {!showTrash &&
          (item?.image ? (
            <Image source={{uri: item?.image}} style={styles?.image} />
          ) : (
            <View
              style={{
                ...styles?.image,
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <MaterialIcons
                name="shopping-cart"
                size={36}
                color={Colors.GrayPallete.lightgrayTwo}
              />
            </View>
          ))} */}
        <View style={styles.spaceItens}>
          <Text style={styles.description} numberOfLines={4}>
            {item?.ARKTX}
          </Text>
            <Text style={styles.description} numberOfLines={4}>
            Quantidade: {item?.KWMENG ? parseFloat(item.KWMENG).toFixed(2).replace(/\.00$/, '') : '0'}
            </Text>
            <View style={styles.containerPrice}>
            <View style={{...styles.statusBadge, backgroundColor: statusColor, marginLeft: 20, marginTop: 10}}>
              <Text style={styles.statusText} numberOfLines={4}>
                {status}
              </Text>
            </View>
          </View>
          <View style={styles.containerPrice}>
              <Text style={{...styles.price, marginLeft: 20, marginTop: 10}} numberOfLines={4}>
              Preço: R$ {item?.CMPRE}
              </Text>
            </View>
        </View>
      </View>)}
      {!!showTrash && (
        <View style={styles.spaceItens}>
          <Text style={styles.description} numberOfLines={4}>
            Não foram encontrados produtos para este pedido!
          </Text>
        </View>
      )}
    </View>
  );
};

export default ProductModalList;
